import { API_BASE_URL } from '../config/apiConfig';

export async function searchProducts(q) {
  const query = (q || '').trim();
  if (!query) return [];

  const url = `${API_BASE_URL}/api/products/search?q=${encodeURIComponent(query)}`;
  const res = await fetch(url);

  if (!res.ok) throw new Error('Search failed');

  const data = await res.json();
  return Array.isArray(data) ? data : [];
}
